import { render, staticRenderFns } from "./alert-message.vue?vue&type=template&id=6f7d6cd7"
import script from "./alert-message.vue?vue&type=script&lang=js"
export * from "./alert-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports